import React from 'react';
import { TextField, Button, Box, Typography, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';

const Step3 = ({ onSubmit, onBack, loading }) => {
  const [age, setAge] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ age });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <form onSubmit={handleSubmit}>
        <Typography variant="h6" gutterBottom>
          Complete Your Profile
        </Typography>
        <TextField
          label="Age"
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onBack}
            disabled={loading}
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Submit'}
          </Button>
        </Box>
      </form>
    </motion.div>
  );
};

export default Step3;